<template>
  <div class="timesheet">
    <div class="row timesheet_expenses">
      <span style="display:none">{{expensesAmount}}</span>
      <div v-for="(expense,index) in expenseList" :key="index"  style="border-top: 1.5px dashed #d4cccc;">
        <div class="form-group row" style="margin-top:14px;">
          <div class="col-md-12">
            <div class="col-md-4">
              <label>Expense Type</label><span class="validation-star">*</span>
              <ob-select2  v-if="showExpenseType" :options="expenseTypeOptions" v-model="expense.expenseType" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].expenseType.$error }"></ob-select2>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].expenseType.$dirty && !$v.expenseList.$each[index].expenseType.required">Enter Expense Type</span>
            </div>
            <div class="col-md-2 pL0 pR0" v-if="expense.expenseType == 'Other'">
              <label>Specify</label><span class="validation-star">*</span>
              <ob-input v-model="expense.specify" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].specify.$error }"></ob-input>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].specify.$dirty && !$v.expenseList.$each[index].specify.requiredIf">Specify Expense Type</span>
            </div>
            <div class="col-md-6">
              <label>Payment Type</label>
              <!-- <span class="validation-star">*</span> -->
              <div class="row">
                <div class="col-md-6">
                  <!-- <ob-radio :name="'ExpensePaidBy'+index"  val="ClientPaid" v-model="expense.ExpensePaidBy" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].ExpensePaidBy.$error }">Client paid Expense</ob-radio> -->
                  <ob-radio :name="'ExpensePaidBy'+index"  val="ClientPaid" v-model="expense.ExpensePaidBy" >Client paid Expense</ob-radio>
                </div>
                <div class="col-md-6">
                  <!-- <ob-radio :name="'ExpensePaidBy'+index"  val="CompanyPaid" v-model="expense.ExpensePaidBy" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].ExpensePaidBy.$error }">Company paid Expense</ob-radio> -->
                  <ob-radio :name="'ExpensePaidBy'+index"  val="CompanyPaid" v-model="expense.ExpensePaidBy" >Company paid Expense</ob-radio>
                </div>
                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].ExpensePaidBy.$dirty && !$v.expenseList.$each[index].ExpensePaidBy.required">Payment is required</span> -->
              </div>
            </div>
            <!-- <div class="col-md-4">
              <label>Select Date Range <i class="fa fa-info-circle" v-tooltip="'The expense range should be only within the timesheet range.'"></i></label><span class="validation-star">*</span>
              <div class="row">
                <div class="col-md-6 pR0">
                  <ob-date-time-picker v-if="showDatepicker" :ref="'dateFrom'+index" :id="'dateFrom'+index" :options="datePickerOptions()" :inputvalue="expense.dateFrom" @updated="(v) => expense.dateFrom = v" @onhide="onFromDateChange(index,...arguments)"  v-model.trim="expense.dateFrom" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].dateFrom.$error }"></ob-date-time-picker>
                  <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].dateFrom.$dirty && !$v.expenseList.$each[index].dateFrom.required">Start date is required</span>
                </div>
                <div class="col-md-6 pR0">
                  <ob-date-time-picker  v-if="showDatepicker"  :ref="'dateTo'+index" :id="'dateTo'+index" :options="datePickerOptions()" :inputvalue="expense.dateTo" @updated="(v) => expense.dateTo = v" v-model.trim="expense.dateTo"  :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].dateTo.$error }"></ob-date-time-picker>
                  <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].dateTo.$dirty && !$v.expenseList.$each[index].dateTo.required">End date is required</span>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-md-2">
              <label>Expense Amount</label><span class="validation-star">*</span>
              <ob-input icon="fa-dollar" @keyup.native="validateAttachments(index)" v-decimal-numbers  :maxLength="10"  v-model="expense.expenseAmount" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].expenseAmount.$error }"></ob-input>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].expenseAmount.$dirty && !$v.expenseList.$each[index].expenseAmount.required">Enter Expense Amount</span>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].expenseAmount.$dirty && $v.expenseList.$each[index].expenseAmount != undefined && !$v.expenseList.$each[index].expenseAmount.minValue">Expense amount must be at-least $1</span>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <div class="col-md-4">
              <label>Expense Amount</label><span class="validation-star">*</span>
              <ob-input icon="fa-dollar" @keyup.native="validateAttachments(index)" v-decimal-numbers  :maxLength="10"  v-model="expense.expenseAmount" :class="{ 'ob-vuelidate_input-error': $v.expenseList.$each[index].expenseAmount.$error }"></ob-input>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].expenseAmount.$dirty && !$v.expenseList.$each[index].expenseAmount.required">Enter Expense Amount</span>
              <span class="ob-vuelidate_error-msg" v-if="$v.expenseList.$each[index].expenseAmount.$dirty && $v.expenseList.$each[index].expenseAmount != undefined && !$v.expenseList.$each[index].expenseAmount.minValue">Expense amount must be at-least $1</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <div class="col-md-12">
              <label>Expense Details</label>
              <ob-textarea :maxLength="1200" v-model="expense.expenseDetails"></ob-textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <div class="attachments_view" style="margin-left: 15px;">
              <template v-for="(AttachmentItem,AttachmentIndex) in expense.AttachBills">
                <div class="attachments-view" >
                  <template>
                    <span>{{getFileName1(AttachmentItem)}}</span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                      <div class="popper" style="padding:0px">
                          <div style="padding:10px;">
                              <span :class="{'cursorCls': !isFileType(AttachmentItem)}" >
                                  <span :class="{'hideShow': !isFileType(AttachmentItem)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(AttachmentItem)" /></span>
                              </span>
                              <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(AttachmentItem)" /></span>
                              <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(AttachmentItem)" /></span>
                          </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
                  </ob-popover>
                  </template>
                  <span >
                    <span class="cross-mark" @click="removeAttachments1(index , AttachmentIndex)" style="font-size: 11px; padding: 2px 5px;" >&#10006;</span>
                  </span>
                </div>
              </template>
              <div v-if="selectedIndex == index && showAttachmentDiv">
                <ob-upload-attachment  :key="iCounter" ref="upload1" @error-msg="IsInvalidFile1" @file-inProgress="InProgress1" @file-complete="onuploadComplete1(index, ...arguments)" :validation="ValidationType" :end-point="EndPoint" :type="1" :IsFileExists="filename1" :attach-file.sync="attachFile">
                  <template slot="file-text">
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                  </template>
                </ob-upload-attachment>
              </div>
              <div class="row">
                <div class="col-md-12 pL0">
                  <div class="col-md-12" style="padding-left:16px;padding-top: 10px;">
                    <a @click="onAddAtachment1(index)">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="margin-right: 5px;"/>
                    <span style="color:#464444;font-weight: 600;">Attach Bills</span>
                    </a>
                  </div>
                  <div class="col-md-12" style="margin-bottom:6px;margin-top:6px;">
                    <span style="font-style: italic;color: #9f9f9f;">We accept either pdf, xls, xlsx, doc, docx, zip, images upto 5MB.</span><span class="validation-star" v-if="expenseList[index].isAttachementreq">*</span>
                  </div>
                  <div class="col-md-12" v-if="projectSelected != null && projectSelected != '' && projectSelected != undefined" style="margin-bottom: 10px;">
                    <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                  v-if="isErrorMessageDisabled" >{{errorMessageFrmResponse}} </span>
                    <span class="ob-vuelidate_error-msg" v-else-if="isValidate && timesheetAttachments">Upload attachments</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-left: 2px;border-top: 1.5px dashed #d4cccc;">
        <div class="col-md-12" style="margin-top: 15px;">
          <a @click="addExpenses(expenseList)">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
            <span style="color:#464444;font-weight: 600;">Add Expense(s)</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import c from 'Vue/Core/constants.js';
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../../CommonFunctionMixin.js'

import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
export default {
  mixins: [CommonFunctionMixin],
  props:["TimeSheetdateFrom", "TimeSheetdateTo","ExpenseModel","projectSelected"],
  data(){
    return{
      iCounter:'',
      isErrorMessageDisabled:false,
      errorMessageFrmResponse:'',
      showExpenseType:true,
      showDatepicker:true,
      specify:'',
      expenseList:[],
      expenseDetails:'',
      dateFrom:'',
      dateTo:'',
      expenseAmount:'',
      orgExpenseAmount:'',
      expenseType:'',
      totalAmount:'',
      isValidate : false,
      AttachBills:[],
      showAttachmentDiv:false,
      filename1:[],
      selectedIndex:'',
      docUrl:'',
      isValidBill:false,
      ValidationType:{
        Rules: {
          Type: ["pdf", "zip", "xls", "xlsx", "doc", "docx", "png", "jpng" , "gif", "jpg", "jpeg"],
          Size: 6000000, // In Bytes
          multiplefiles:true
        },
        Messages: {
          Type: "Please upload valid file formats",
          Size: `Please upload a file which is less than 5MB`,
        },
        excludeList:false
      },
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachFile:false,
      expenseTypeOptions: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      },
      ExpensePaidBy:'',
    }
  },
  validations() {
    return{
      "expenseList":
        {
        $each: {
          "expenseType":{
            required
          },
          "specify":{
            requiredIf: requiredIf((d) => {
              if(d.expenseType == 'Other'){
                return true
              }else{
                return false
              }
            })
          },
          "ExpensePaidBy":{},
          // "dateFrom":{
          //   required
          // },
          // "dateTo":{
          //   required
          // },
          "expenseAmount":{
            required,
            minValue: minValue(1),
          },
        }
      },
    }
  },
  created(){
    events.listen('hideExpenseOption',(val)=>{
            this.showExpenseType = val
            })
    this.getExpenseSettings();
    this.formatTimesheetExpanseObjectForGet();
  },
  computed: {
    expensesAmount(){
      this.totalAmount = 0;
      for(var i=0 ; i < this.expenseList.length ; i++){
        if(this.expenseList[i].expenseAmount != "" && this.expenseList[i].expenseAmount != null){
        this.totalAmount = (parseFloat(this.totalAmount) || 0) + (parseFloat(this.expenseList[i].expenseAmount) || 0);
        this.$emit('expensesAmount',this.totalAmount);
        }
        else this.$emit('expensesAmount',this.totalAmount);
      }
      return this.totalAmount;
    },
  },
  watch:{
    TimeSheetdateFrom()
    {
      this.showDatepicker = false;
      setTimeout(() => {
        this.showDatepicker = true;
      }, 10)
      // this.dateRangeValidation();
    },
    TimeSheetdateTo()
    {
      this.showDatepicker = false;
      setTimeout(() => {
       this.showDatepicker = true;
      }, 10)
      // this.dateRangeValidation();
    }
  },
  methods:{

    dateRangeValidation()
    {
      var timesheetFrom = new Date(this.TimeSheetdateFrom).getTime();
      var timesheetTo = new Date(this.TimeSheetdateTo).getTime();

      for(var i= 0 ; i < this.expenseList.length ; i ++)
      {
          var expFrom =  new Date(this.expenseList[i].dateFrom).getTime();
          var expTo =  new Date(this.expenseList[i].dateTo).getTime();

          if(!(expFrom >= timesheetFrom && expFrom <= timesheetTo))
          {
             this.expenseList[i].dateFrom = ''
          }
          if(!(expTo >= timesheetFrom && expTo <= timesheetTo))
          {
             this.expenseList[i].dateTo = ''
          }
      }
    },
    datePickerOptions(){
      var options4 = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate : moment(this.TimeSheetdateFrom).format('MM/DD/YYYY'),
        maxDate : moment(this.TimeSheetdateTo).format('MM/DD/YYYY'),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      }
      return options4
    },
    validateAttachments(ind){
      if(parseFloat(this.expenseList[ind].expenseAmount) > parseFloat(this.orgExpenseAmount)){
        if(this.expenseAttachmentCount(ind) > 0){
          this.expenseList[ind].isAttachementreq = false
          //this.isValidate = false
        }else{
          this.expenseList[ind].isAttachementreq = true
          //this.isValidate = true
        }
      }else{
        this.expenseList[ind].isAttachementreq = false
        // this.isValidate = false
      }

      console.log("test",this.expenseList[ind].isAttachementreq)
      //return this.expenseList[ind].isAttachementAdded
    },
    expenseAttachmentCount(ind){
      if(this.expenseList[ind].AttachBills.length > 0)
        return this.expenseList[ind].AttachBills.length
    },


    // Add attch bills for Expenses block
    removeAttachments1(index,AttachmentIndex){
      this.$alert2(`Are you sure you want to delete ?`, "Alert", {
          type: "confirm",
          yesButtonText: "Yes",
          noButtonText: "No",
          callback: (action) => {
            if(action === true) {
              this.expenseList[index].AttachBills.splice(AttachmentIndex , 1)
              this.validateAttachments(index)
            }
          }
         })
    },
    onuploadComplete1(index,v) {
      if(this.expenseList.length > 0)
      {
        for(var i=0 ; i<v.length ; i++)
        {
          if (v[i].response.Url != null)
          this.expenseList[this.selectedIndex].AttachBills.push(v[i].response.Url)
          this.isErrorMessageDisabled = false
        }
        if (v[0].response.State == false && v[0].response.Message != null)
        {
          this.iCounter++
          this.isErrorMessageDisabled = true
          this.errorMessageFrmResponse = v[0].response.Message
        }
        this.showAttachmentDiv = false
        this.selectedIndex = '';
        this.validateAttachments(index);
        this.$loading({}).close();
      }
    },
    onAddAtachment1(x)
    {
      if(this.expenseList.length > 0)
      {
        this.showAttachmentDiv = true
        this.selectedIndex = x ;
        this.open1(x);
      }
    },
    InProgress1()
    {
      this.$loading({'loadingText': 'Loading...'})
      this.showAttachmentDiv = true
    },
    getFileName1(AttachmentItem)
    {
      if(this.expenseList.length > 0)
      {
        var filename1 = utils.I9URL2FileName(AttachmentItem);
        var fileLength = filename1.length
        if(fileLength > 33)
        {
        return filename1.substring(0,30) + "...";
        }
        else return filename1
      }
    },
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    open1(v) {
      setTimeout(() => {
        this.$refs.upload1[0].uploadNew();
      }, 1000)
    },
    IsInvalidFile1(error)
    {
      if(error != '')
      {
        this.$message({
          type: 'error',
          message: error
        });
      }
    },
    // End of Add attch bills for Expenses block

    // To Remove Expense block
    onRemoveExpense(index){
      this.$v.expenseList.$each[index].$reset()
      this.expenseList.splice(index,1)
    },

    // To add Expense block
    addExpenses(arr) {
      arr.push({
        Id:'',
        expenseType: '',
        specify:'',
        // dateFrom:'',
        // dateTo:'',
        expenseDetails: '',
        expenseAmount:'',
        AttachBills:[],
        isAttachementreq:false,
        ExpensePaidBy:'',
      })
    },
    onFromDateChange(index,e) {
      let dateToFormat = moment(e._d).format('MM/DD/YYYY');
      var x = 'dateTo'+index
      setTimeout(() => {
        this.$refs[x][0].data.minDate(dateToFormat)
      }, 100)
    },

    // To get Expense types in Expense
    getExpenseSettings(){
      this.showExpenseType = false
      this.$loading({'loadingText': 'Loading...'})
      ajax.get(`Expense/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
        if(res.data.State == true){
          this.orgExpenseAmount = res.data.ExpenseSettings.ExpenseAmount
          let expenseTypes = res.data.ExpenseSettings.ExpenseTypes
          this.expenseTypeOptions.data = __.map(expenseTypes, (t) => {
            // return {'id' : t , 'text' : t}
            return {'id' : t.Id , 'text' : t.Name}
          })
          this.expenseTypeOptions.data.push({'id' : "Other" , 'text' : "Other"})
          this.showExpenseType = true
        }
        else{
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },

    // Binding the Expenses
    formatTimesheetExpanseObjectToSave()
    {
      var expanceModel = [];
      Array.prototype.forEach.call(this.expenseList, item => {
        let obj = {
          Id:item.Id,
          ExpenseType:item.expenseType,
          ExpenseAmount:item.expenseAmount,
          ExpenseDetails:item.expenseDetails,
          // FromDate:item.dateFrom,
          // ToDate:item.dateTo,
          // PaymentType: item.ExpensePaidBy != null ? item.ExpensePaidBy : 'CompanyPaid',
          PaymentType: item.ExpensePaidBy,
          AttachmentUrls:item.AttachBills,
          SpecifyReason :item.specify,
          isAttachementreq:item.isAttachementreq
        }
        expanceModel.push(obj)
      });
      return expanceModel;
    },

    // Getting the Expenses in Edit Mode
    formatTimesheetExpanseObjectForGet()
    {
      Array.prototype.forEach.call(this.ExpenseModel, item => {
        let obj = {
          Id:item.Id,
          expenseType:item.ExpenseType,
          expenseAmount:item.ExpenseAmount,
          expenseDetails:item.ExpenseDetails,
          // dateFrom:item.FromDate,
          // dateTo:item.ToDate,
          // ExpensePaidBy: item.PaymentType != null ? item.PaymentType : 'CompanyPaid',
          ExpensePaidBy: item.PaymentType,
          AttachBills:item.AttachmentUrls,
          specify  :item.SpecifyReason,
          isAttachementreq:item.isAttachementreq
        }
        this.expenseList.push(obj)
      });
    },

    // Validations checking
    saveExpenses()
    {
      let isAttachementrequired = this.expenseList.filter((v) => v.isAttachementreq == true).map(function(v) {
          return v.isAttachementreq;
        });

        if(isAttachementrequired.length > 0){
            this.isValidate = true
        }
        else{
          this.isValidate = false
        }
      this.$v.expenseList.$touch();
      let isValid = true;
      if(this.expenseList.length > 0)
      {
        isValid = true;
        for(var i = 0 ;i < this.expenseList.length; i++){
          if (this.$v.expenseList.$each[i].expenseType.$error || this.$v.expenseList.$each[i].specify.$error
          // || this.$v.expenseList.$each[i].dateFrom.$error || this.$v.expenseList.$each[i].dateTo.$error
          || this.$v.expenseList.$each[i].expenseAmount.$error || this.isValidate
          // || this.$v.expenseList.$each[i].ExpensePaidBy.$error
        )
          {
            isValid = false;
            break;
        } else
          isValid = true
        }
      }
      if(!isValid){
        isValid = false
      }
      else{
        isValid = true
      }
      this.$emit('isValidExpenses',isValid)
    },
  }
}
</script>
<style lang="scss" scoped>
 .validation-star{
    color: #F31D1D;
  }
  .timesheet_expenses{
    padding: 15px;
    padding-top:5px;
    margin-bottom: 10px;
   }
  .block{
    border-top: 1.5px dashed #d4cccc;
  }
  .attachments_view{
      p{
        font-weight: 600;
      }
    .form-group {
      margin-left: -16px;
      margin-top: 15px;
      label{
          font-weight: 600;
          font-size: 11px;
      }
    }
    .attachments-view
    {
     margin-bottom: 5px;
      margin-left: 0px;
      border: 1px solid #4A90E2 !important;
      background: #e6eff9  !important;
      padding: 4px 4px 4px 10px;
      display: inline-block;
      border-radius: 30px;
      font-weight: 600;
      float: left;
      margin-right: 2%;
      font-size: 11px;
    }
    .cross-mark{
      font-size: 15px;
      padding: 0px 5px;
      border-radius: 100%;
      cursor: pointer;
    }
    .cross-mark:hover{
      background:  #c2c2c2;
      padding: 0px 5px;
      border-radius: 100%;
      text-decoration: none !important;
    }
    .task-title:hover
    {
        color:#4A90E2;
        cursor: pointer;
    }
    .cursorCls
    {
      cursor:not-allowed !important;
    }
    .hideShow
    {
      pointer-events: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/ApprovalFlow/EmployerEditExpanses.vue